import Cookie from 'js-cookie';
import { ModalConfig } from 'types';

import { USER_REQUEST_PATH_COOKIE } from 'utils/constants';

export const notAuthenticatedConfig: ModalConfig = {
  title: 'Not Authenticated',
  content: 'Your session has expired. Please click OK to log in again',
  onConfirmation: () => {
    // Redirect to the current url after user login
    Cookie.set(USER_REQUEST_PATH_COOKIE, window.location.href, {
      domain: import.meta.env.VITE_DEFAULT_COOKIE_DOMAIN,
    });
    window.location.replace(import.meta.env.VITE_CALIX_PORTAL_LOGIN_URL);
  },
};
